export default "__VITE_PUBLIC_ASSET__cf15ffb9__"